<section>
  <div class="label">STREAM ASPECT RATIO:</div>
  <radio-collection [options]="ratioOptions" [key]="'ratio'"></radio-collection>
</section>
<section>
  <div class="label">POST AS:</div>
  <icn-dropdown [selectedValue]="'Eran Tal'">
    <icn-dropdown-item [title]="'Eran Tal'" [value]="'Eran Tal'">
    </icn-dropdown-item>
  </icn-dropdown>
  <div class="label note">
    (Choose between your personal profile, pages or groups you admin)
  </div>
</section>
<section>
  <div class="label">NAME YOUR STREAM:</div>
  <input type="text" [placeholder]="'Example: Eran\'s stream'" />
</section>
<section>
  <div class="label">SHARE WITH:</div>
  <icn-dropdown [selectedValue]="'Public'">
    <icn-dropdown-item [title]="'Public'" [value]="'Public'">
    </icn-dropdown-item>
  </icn-dropdown>
</section>
